// GraphQl
import { gql } from 'apollo-boost';

export const LIST_PARTICIPANT_RAISING = gql`
  query listParticipantRaising($raising: ID!) {
    listParticipantRaising(id: $raising) {
      edges {
        node {
          numFee
          amount
          createdDate
          updatedDate
          validated
          isApproved
          isDisabled
          participationType
          classFund {
            name
          }
          lastParticipation {
            id
            order
            state
            participationPercentage
            contractGenerated
            coParticipants {
              edges {
                node {
                  participationPercentage
                  client {
                    user {
                      firstName
                      lastName
                      maternalSurname
                    }
                  }
                }
              }
            }
          }
          raising {
            fund {
              currency {
                symbol
              }
            }
          }
          client {
            id
            user {
              firstName
              lastName
              maternalSurname
            }
          }
        }
      }
    }
  }
`;

export const GET_PARTICIPANT_RAISING = gql`
  query getParticipantRaising($id: ID!) {
    ParticipantRaising(id: $id) {
      id
      name
      numSent
      dateInitial
      dateEnd
      dateAward
      numToSend
      fundInvestors
      fundInvestorsPastWheel
      fundInvestorsOtherFunds
      interestedInvestors
    }
  }
`;

export const UPDATE_PARTICIPANT_RAISING = gql`
  mutation updateParticipantRaisingl(
    $id: ID!
    $input: ParticipantRaisingInput!
  ) {
    updateParticipantRaising(id: $id, input: $input) {
      wheel {
        id
        name
        numSent
        dateInitial
        dateEnd
        dateAward
        numToSend
        fundInvestors
        fundInvestorsPastWheel
        fundInvestorsOtherFunds
        interestedInvestors
      }
      errors {
        field
        message
      }
    }
  }
`;

export const DELETE_PARTICIPANT_RAISING = gql`
  mutation deleteParticipant($id: ID!) {
    deleteParticipant(id: $id) {
      participant {
        id
      }
      errors {
        field
        message
      }
    }
  }
`;

export const ADJUDICATE_PARTICIPANT_RAISING = gql`
  mutation adjudication($id: ID!) {
    adjudication(id: $id) {
      participation {
        id
        state
      }
    }
  }
`;

export const GENERATE_CONTRACT = gql`
  mutation generateParticipantContract($id: ID!) {
    generateParticipantContract(id: $id) {
      created
    }
  }
`;

export const VERIFY_PARTICIPANT_PAYMENT = gql`
  mutation updateParticipantStatusVerify($id: ID!) {
    updateParticipantStatusVerify(id: $id) {
      participant {
        id
        state
      }
    }
  }
`;

export const PARTICIPANT_RAISING_REPORT = gql`
  query participantRaisingReport($raising: ID) {
    participantRaisingReport(raisingId: $raising) {
      csv
      filename
    }
  }
`;

export const GET_PARTICIPANT_CONTRACT = gql`
  query contractPdf($participantId: ID) {
    contractPdf(participantId: $participantId) {
      pdf
      filename
    }
  }
`;

export const RAISING_ORDER = gql`
  query raisingOrder($raisingId: ID, $clientId: ID) {
    raisingOrder(raisingId: $raisingId, clientId: $clientId) {
      pdf
      filename
    }
  }
`;
